<template>
<div class="cover_container">
    <section class="content_box">
        <div ref="content" class="card_content">
            <slot></slot>
        </div>
    </section>
</div>
</template>

<script>
</script>

<style lang="less" scoped>
@media screen and (min-width: 820px) {
    .card_content {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 700px) and (max-width: 820px) {
    .card_content {
        grid-template-columns: repeat(2, 1fr);
    }
}


@media screen and (max-width: 700px) {
    .card_content {
        grid-template-columns: repeat(1, 1fr);
    }
}

.cover_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.content_box {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    width: 100%;
}

.card_content {
    display: grid;
    column-gap: 1rem;
    row-gap: 2rem;
}


</style>
  